export default "__VITE_ASSET__q$W1ANZx__"